/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Howtoclaimbody3Inputs */

const id_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendapatkan salinan gratis Anda mudah!`)
};

const ms_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendapatkan salinan percuma anda mudah!`)
};

const da_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At få din gratis kopi er nemt!`)
};

const de_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre kostenlose Kopie zu bekommen ist einfach!`)
};

const en_us2_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting your free copy is easy!`)
};

const es_es2_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Conseguir tu copia gratis es fácil!`)
};

const es_mx2_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Conseguir tu copia gratis es fácil!`)
};

const fil_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang pagkuha ng iyong libreng kopya ay madali!`)
};

const fr_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir votre copie gratuite est simple !`)
};

const it_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottenere la tua copia gratuita è facile!`)
};

const hu_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az ingyenes példány megszerzése egyszerű!`)
};

const nl_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je gratis exemplaar krijgen is eenvoudig!`)
};

const no_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Å få din gratis kopi er enkelt!`)
};

const pl_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdobycie darmowej kopii jest łatwe!`)
};

const pt_br2_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obter sua cópia gratuita é fácil!`)
};

const pt_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obter a sua cópia grátis é fácil!`)
};

const ro_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obținerea copiei gratuite este ușoară!`)
};

const fi_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaiskappaleen saaminen on helppoa!`)
};

const sv_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Att få din gratis kopia är enkelt!`)
};

const vi_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận bản sao miễn phí của bạn thật dễ dàng!`)
};

const tr_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz kopyanızı almak çok kolay!`)
};

const cs_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získání vaší bezplatné kopie je snadné!`)
};

const bg_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вземането на безплатното копие е лесно!`)
};

const ru_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получить бесплатную копию очень просто!`)
};

const uk_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримати безкоштовну копію легко!`)
};

const ar_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحصول على نسختك المجانية سهل!`)
};

const hi_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी मुफ़्त कॉपी प्राप्त करना आसान है!`)
};

const th_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การรับเกมฟรีของคุณเป็นเรื่องง่าย!`)
};

const ja_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料コピーの入手は簡単です！`)
};

const zh_cn2_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`领取免费副本非常简单！`)
};

const zh_hant1_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`領取免費副本非常簡單！`)
};

const ko_misc_posts_howtoclaimbody3 = /** @type {(inputs: Misc_Posts_Howtoclaimbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 사본을 받는 것은 쉽습니다!`)
};

/**
* | output |
* | --- |
* | "Getting your free copy is easy!" |
*
* @param {Misc_Posts_Howtoclaimbody3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_howtoclaimbody3 = /** @type {((inputs?: Misc_Posts_Howtoclaimbody3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Howtoclaimbody3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_howtoclaimbody3(inputs)
	if (locale === "ms") return ms_misc_posts_howtoclaimbody3(inputs)
	if (locale === "da") return da_misc_posts_howtoclaimbody3(inputs)
	if (locale === "de") return de_misc_posts_howtoclaimbody3(inputs)
	if (locale === "en-US") return en_us2_misc_posts_howtoclaimbody3(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_howtoclaimbody3(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_howtoclaimbody3(inputs)
	if (locale === "fil") return fil_misc_posts_howtoclaimbody3(inputs)
	if (locale === "fr") return fr_misc_posts_howtoclaimbody3(inputs)
	if (locale === "it") return it_misc_posts_howtoclaimbody3(inputs)
	if (locale === "hu") return hu_misc_posts_howtoclaimbody3(inputs)
	if (locale === "nl") return nl_misc_posts_howtoclaimbody3(inputs)
	if (locale === "no") return no_misc_posts_howtoclaimbody3(inputs)
	if (locale === "pl") return pl_misc_posts_howtoclaimbody3(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_howtoclaimbody3(inputs)
	if (locale === "pt") return pt_misc_posts_howtoclaimbody3(inputs)
	if (locale === "ro") return ro_misc_posts_howtoclaimbody3(inputs)
	if (locale === "fi") return fi_misc_posts_howtoclaimbody3(inputs)
	if (locale === "sv") return sv_misc_posts_howtoclaimbody3(inputs)
	if (locale === "vi") return vi_misc_posts_howtoclaimbody3(inputs)
	if (locale === "tr") return tr_misc_posts_howtoclaimbody3(inputs)
	if (locale === "cs") return cs_misc_posts_howtoclaimbody3(inputs)
	if (locale === "bg") return bg_misc_posts_howtoclaimbody3(inputs)
	if (locale === "ru") return ru_misc_posts_howtoclaimbody3(inputs)
	if (locale === "uk") return uk_misc_posts_howtoclaimbody3(inputs)
	if (locale === "ar") return ar_misc_posts_howtoclaimbody3(inputs)
	if (locale === "hi") return hi_misc_posts_howtoclaimbody3(inputs)
	if (locale === "th") return th_misc_posts_howtoclaimbody3(inputs)
	if (locale === "ja") return ja_misc_posts_howtoclaimbody3(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_howtoclaimbody3(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_howtoclaimbody3(inputs)
	return ko_misc_posts_howtoclaimbody3(inputs)
});
export { misc_posts_howtoclaimbody3 as "misc.posts.howToClaimBody" }